<script setup lang="ts">
import SearchField from '@/components/filter/SearchField.vue';
import { I18nKey } from '@/utils/typings';
import { RolesOverviewFilterObject } from '../types';
import PtwResetFilterButton from '@/components/buttons/PtwResetFilterButton.vue';

const modelValue = defineModel<RolesOverviewFilterObject>({ required: true });
const searchedFieldsI18nKeys: I18nKey[] = ['Search'];

function clearFilters() {
  modelValue.value = {};
}
</script>

<template>
  <v-row class="align-center mt-2 pl-2 pr-2">
    <v-col cols="12" sm="6" md="5" lg="3" class="pa-2">
      <SearchField
        v-model="modelValue.search"
        :placeholder="
          $t('SearchPlaceholder', {
            columns: searchedFieldsI18nKeys.map((key) => `$t(${key})`),
          })
        "
      />
    </v-col>
    <v-col cols="12" sm="6" md="2" lg="2" class="d-flex align-center justify-start pa-2">
      <PtwResetFilterButton @click="clearFilters">{{ $t('ResetFilter_one') }}</PtwResetFilterButton>
    </v-col>
  </v-row>
</template>
